import React from "react";
import { Button, Table } from "react-bootstrap";

const TableData = ({ AccountingData }) => {
  return (
    <>
      <Table responsive>
        <thead>
          <tr>
            <th className="fw-normal border-0">User Name</th>
            <th className="fw-normal border-0">Plan Name</th>
            <th className="fw-normal border-0">Amount Paid</th>
            <th className="fw-normal border-0">Start Date</th>
            <th className="fw-normal border-0">Payment Status</th>
          </tr>
        </thead>
        <tbody>
          {AccountingData && AccountingData.length > 0 ? (
            AccountingData?.map((data, index) => (
              <tr key={index}>
                <td className="text-capitalize">{data?.user_name || "-"}</td>
                <td>{data?.plan_name || "-"}</td>
                <td>{`$ ${(data?.amount_paid / 100).toFixed(2) || "-"}`}</td>
                <td>
                  {data?.start_date
                    ? new Date(data.start_date).toLocaleDateString()
                    : "-"}
                </td>
                <td className="text-capitalize">{data?.plan_status || "-"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No data available</td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};


export default TableData;
